(function () {
  var replacements = {
    'Hatfield Mccoy DTF': 'Hatfield McCoy DTF',
    'Hatfield & McCoy DTF': 'Hatfield McCoy DTF',
    'Hatfield and McCoy DTF': 'Hatfield McCoy DTF',
    'Hatfield And McCoy DTF': 'Hatfield McCoy DTF'
  };
  function cleanText(node) {
    if (!node || !node.nodeValue) return;
    var text = node.nodeValue;
    Object.keys(replacements).forEach(function (bad) {
      text = text.split(bad).join(replacements[bad]);
    });
    node.nodeValue = text;
  }
  function walk(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) cleanText(node);
  }
  function run() {
    Object.keys(replacements).forEach(function (bad) { document.title = document.title.split(bad).join(replacements[bad]); });
    if (document.body) walk(document.body);
  }
  function centsToDecimal(cents) {
    var n = Number(cents || 0) / 100;
    return n.toFixed(2);
  }
  function getKixxlForm() {
    return document.querySelector('.gangify-form');
  }
  function getProductMeta() {
    return window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
  }
  function getSelectedOptionLabel() {
    var checked = document.querySelector('variant-picker input[type="radio"]:checked, input[type="radio"][name^="Length"]:checked, input[type="radio"]:checked');
    return checked ? String(checked.value || checked.getAttribute('aria-label') || '').trim() : '';
  }
  function getSelectedQuantity() {
    var input = document.querySelector('quantity-selector-component input[name="quantity"], input[name="quantity"], input[type="number"][aria-label*="Quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }
  function getSelectedVariant(variants) {
    var selectedShopifyVariant = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"][type="hidden"], select[name="id"]');
    var byId = selectedShopifyVariant && variants.find(function (variant) { return String(variant.id) === String(selectedShopifyVariant.value); });
    if (byId) return byId;
    var optionLabel = getSelectedOptionLabel();
    var byLabel = optionLabel && variants.find(function (variant) {
      return String(variant.public_title || '').trim() === optionLabel || String(variant.name || '').split(' - ').pop().trim() === optionLabel;
    });
    return byLabel || variants[0];
  }
  function ensureKixxlVariantInputs() {
    var meta = getProductMeta();
    var form = getKixxlForm();
    if (!meta || !form) return;

    form.style.display = '';

    var productInput = form.querySelector('#gangify-product-id');
    if (productInput) productInput.value = String(meta.id || '').trim();

    form.querySelectorAll('.gangify-variant').forEach(function (el) { el.remove(); });
    var variants = Array.isArray(meta.variants) ? meta.variants : [];
    variants.forEach(function (variant) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.className = 'gangify-variant';
      input.value = variant.public_title || variant.name || '';
      input.setAttribute('data-id', variant.id);
      input.setAttribute('data-price', centsToDecimal(variant.price));
      form.appendChild(input);
    });

    var selected = getSelectedVariant(variants);
    var defaultInput = form.querySelector('#gangify-default-variant');
    if (defaultInput && selected) {
      defaultInput.value = selected.public_title || selected.name || '';
      defaultInput.setAttribute('data-id', selected.id);
      defaultInput.setAttribute('data-price', centsToDecimal(selected.price));
    }
    var selectedKixxlVariant = form.querySelector('#selected-variant');
    if (selectedKixxlVariant && selected) selectedKixxlVariant.value = String(selected.id);
  }
  function openKixxlBuilder(uploadMode) {
    ensureKixxlVariantInputs();
    var meta = getProductMeta();
    var form = getKixxlForm();
    var variants = meta && Array.isArray(meta.variants) ? meta.variants : [];
    var selected = getSelectedVariant(variants);
    var shopInput = form && form.querySelector('#gangify-shop-domain');
    var localeInput = form && form.querySelector('#kixxl-shop-locale');
    if (!meta || !selected || !shopInput || !shopInput.value) return false;
    var params = new URLSearchParams();
    params.set('variant', String(selected.id));
    params.set('price', centsToDecimal(selected.price));
    params.set('store', shopInput.value);
    params.set('product', String(meta.id));
    params.set('quantity', String(getSelectedQuantity()));
    if (localeInput && localeInput.value) params.set('locale', localeInput.value);
    if (uploadMode) params.set('upload', 'true');
    window.location.href = '/apps/gangify/builder?' + params.toString();
    return true;
  }
  function installKixxlSync() {
    ensureKixxlVariantInputs();
    document.addEventListener('change', function (event) {
      if (event.target && (event.target.matches('input[type="radio"]') || event.target.name === 'id' || event.target.name === 'quantity')) {
        setTimeout(ensureKixxlVariantInputs, 25);
      }
    }, true);
    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest && event.target.closest('#submit-link, #upload-link');
      if (button) {
        ensureKixxlVariantInputs();
        if (openKixxlBuilder(button.id === 'upload-link')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }
    }, true);
    setTimeout(ensureKixxlVariantInputs, 250);
    setTimeout(ensureKixxlVariantInputs, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ run(); installKixxlSync(); }); else { run(); installKixxlSync(); }
  var observer = new MutationObserver(function (mutations) {
    var shouldSync = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 3) cleanText(node);
        else if (node.nodeType === 1) { walk(node); if (node.matches && (node.matches('.gangify-form') || node.querySelector('.gangify-form'))) shouldSync = true; }
      });
    });
    if (shouldSync) setTimeout(ensureKixxlVariantInputs, 25);
  });
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();
